type LocationStatus = "active" | "inactive" | "idle" | "total";

interface LocationCardItemProps {
  type: LocationStatus;
  label: string;
  count: number;
}

const LocationCardItemStatus = ({
                                  type,
                                  label,
                                  count
                                }: LocationCardItemProps) => {

  const COLOR_MAPPER: Record<LocationStatus, string> = {
    "active": "green",
    "inactive": "red",
    "idle": "orange",
    "total": "gray"
  }

  return (
    <div className={"flex items-center gap-0.5 text-xs"}>
      <span className={"w-2 h-2 mr-1.5 flex rounded-full "} style={{
        background: COLOR_MAPPER[type]
      }}></span>
      <span>{label}:</span>
      <span className={"font-bold"}>{count}</span>
    </div>
  )
}


export default LocationCardItemStatus;